import SingleRoom from './SingleRoom'

export default SingleRoom



// WEBPACK FOOTER //
// ./src/features/Hotel/components/SingleRoom/index.js